import React from "react"
import LayoutNM from "../components/Layout/Layout"
import { graphql, Link } from "gatsby"
import ArticlesGrid from "../article-components/articles-grid"
import Seo from "../utils/Seo"
import SearchBar2 from "../components/Layout/SearchBar2"

const BlogPosts = ({ pageContext, data, location }) => {
  const { currentPage, numPages } = pageContext
  const posts = data.allStrapiArticle.nodes
  const isFirst = currentPage === 1
  const isLast = currentPage === numPages
  const prevPage = currentPage - 1 === 1 ? "/blog" : `/blog/${currentPage - 1}`
  const nextPage = `/blog/${currentPage + 1}`
  const getPageNumberPath = currentIndex => {
    if (currentIndex === 0) {
      return "/blog"
    }
    return "/blog/" + (currentIndex + 1)
  }
  const prevPageClassName = isFirst ? "disabled" : "pagination-button"
  const nextPageClassName = isLast ? "disabled" : "pagination-button"

  return (
    <LayoutNM type="navbar" location={location}>
      <SearchBar2 />
      <Seo seo={{ metaTitle: "Todos nuestros artículos  - Dalia Empower" }} />
      <div className={`container news`}> {/* news esta de mas */}
        <main className="main-blog">
          <h1>Todos nuestros artículos: </h1>
          <ArticlesGrid articles={posts} />
        </main>
        <div className="pagination">
          <Link className={prevPageClassName} to={prevPage} rel="prev">
            &larr; Prev
          </Link>
          {Array.from({ length: numPages }, (_, i) => {
            let pageNumberClassName = "pagination-number"
            if (currentPage === i + 1) {
              pageNumberClassName = "pagination-number-active"
            }
            return (
              <Link
                className={pageNumberClassName}
                key={i + 1}
                to={getPageNumberPath(i)}
              >
                {i + 1}
              </Link>
            )
          })}
          <Link className={nextPageClassName} to={nextPage} rel="next">
            Next &rarr;
          </Link>
        </div>
      </div>
    </LayoutNM>
  )
}

export default BlogPosts

export const query = graphql`
  query GetAllPostFilter($skip: Int!, $limit: Int!, $language: String!) {
    allStrapiArticle(
      limit: $limit
      skip: $skip
      sort: {date: DESC}
    ) {
      nodes {
        id
        date
        slug
        subtitle
        title
        isFeatured
        description
        cover {
          alternativeText
          localFile {
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED)
            }
          }
        }
      }
    }
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
